import PrimeVue, { defaultOptions } from 'primevue/config';
import AutoComplete from 'primevue/autocomplete'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
// import AvatarGroup from 'primevue/avatargroup'
import Badge from 'primevue/badge'
// import BadgeDirective from 'primevue/badgedirective'
// import BlockUI from 'primevue/blockui'
// import Breadcrumb from 'primevue/breadcrumb'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import Card from 'primevue/card'
import Carousel from 'primevue/carousel'
// import CascadeSelect from 'primevue/cascadeselect'
import Chart from 'primevue/chart'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import Chips from 'primevue/chips'
// import ColorPicker from 'primevue/colorpicker'
import Column from 'primevue/column'
// import ColumnGroup from 'primevue/columngroup'
// import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmPopup from 'primevue/confirmpopup'
import ConfirmationService from 'primevue/confirmationservice'
// import ContextMenu from 'primevue/contextmenu'
import DataTable from 'primevue/datatable'
import DataView from 'primevue/dataview'
//import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'
// import DeferredContent from 'primevue/deferredcontent'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import Editor from 'primevue/editor'
// import Fieldset from 'primevue/fieldset'
import FileUpload from 'primevue/fileupload'
// import FullCalendar from 'primevue/fullcalendar'
import Image from 'primevue/image';
// import InlineMessage from 'primevue/inlinemessage'
// import Inplace from 'primevue/inplace'
// import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
// import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
//import Knob from 'primevue/knob'
// import Listbox from 'primevue/listbox'
// import MegaMenu from 'primevue/megamenu'
// import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import Message from 'primevue/message'
import MultiSelect from 'primevue/multiselect'
// import OrderList from 'primevue/orderlist'
// import OrganizationChart from 'primevue/organizationchart'
import OverlayPanel from 'primevue/overlaypanel'
import Paginator from 'primevue/paginator'
// import Panel from 'primevue/panel'
import PanelMenu from 'primevue/panelmenu'
import Password from 'primevue/password'
// import PickList from 'primevue/picklist'
import ProgressBar from 'primevue/progressbar'
// import ProgressSpinner from 'primevue/progressspinner'
import Rating from 'primevue/rating'
import RadioButton from 'primevue/radiobutton'
import Ripple from 'primevue/ripple'
// import Row from 'primevue/row'
// import ScrollPanel from 'primevue/scrollpanel'
// import ScrollTop from 'primevue/scrolltop'
import SelectButton from 'primevue/selectbutton'
import Skeleton from 'primevue/skeleton'
// import Slider from 'primevue/slider'
// import Sidebar from 'primevue/sidebar'
// import SplitButton from 'primevue/splitbutton'
// import Splitter from 'primevue/splitter'
// import SplitterPanel from 'primevue/splitterpanel'
import Steps from 'primevue/steps'
// import TabMenu from 'primevue/tabmenu'
// import TabView from 'primevue/tabview'
// import TabPanel from 'primevue/tabpanel'
import Tag from 'primevue/tag'
// import Terminal from 'primevue/terminal'
import Textarea from 'primevue/textarea'
// import TieredMenu from 'primevue/tieredmenu'
import Timeline from 'primevue/timeline'
import Tree from 'primevue/tree'
// import TreeTable from 'primevue/treetable'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
// import ToggleButton from 'primevue/togglebutton'
// import Toolbar from 'primevue/toolbar'
import Tooltip from 'primevue/tooltip'
// import TriStateCheckbox from 'primevue/tristatecheckbox'
import Galleria from 'primevue/galleria'
import 'chart.js/auto'
import { fallbackLocale, locale } from '@/plugins/i18n'

export const registerPrimeVue = (app) => {
    const getLocaleMessages = () => {
        const localeFiles = require.context('@/locales/primevue', true, /[\w-]+\.json$/i)
        const locales = localeFiles.keys().reduce((locs, loc) => ({ ...locs, [loc.replace(/\.|\/|json/g, '')]: localeFiles(loc) }), {})
        return locale in locales ? locales[locale] : defaultOptions.locale
    }

    const localeMessages = getLocaleMessages()

    app.use(PrimeVue, {
        ripple: true,
        locale: { ...defaultOptions.locale , ...localeMessages }
    })
    app.use(ToastService)
    app.use(ConfirmationService)

    //app.directive('badge', BadgeDirective)
    app.directive('tooltip', Tooltip)
    app.directive('ripple', Ripple)

    app.component('Accordion', Accordion)
    app.component('AccordionTab', AccordionTab)
    app.component('Avatar', Avatar)
    // app.component('AvatarGroup', AvatarGroup)
    app.component('AutoComplete', AutoComplete)
    app.component('Badge', Badge)
    // app.component('BlockUI', BlockUI)
    // app.component('Breadcrumb', Breadcrumb)
    app.component('Button', Button)
    app.component('Calendar', Calendar)
    app.component('Card', Card)
    app.component('Carousel', Carousel)
    // app.component('CascadeSelect', CascadeSelect)
    app.component('Chart', Chart)
    app.component('Checkbox', Checkbox)
    app.component('Chip', Chip)
    app.component('Chips', Chips)
    // app.component('ColorPicker', ColorPicker)
    app.component('Column', Column)
    // app.component('ColumnGroup', ColumnGroup)
    // app.component('ConfirmDialog', ConfirmDialog)
    app.component('ConfirmPopup', ConfirmPopup)
    // app.component('ContextMenu', ContextMenu)
    app.component('DataTable', DataTable)
    app.component('DataView', DataView)
    //app.component('DataViewLayoutOptions', DataViewLayoutOptions)
    // app.component('DeferredContent', DeferredContent)
    app.component('Dialog', Dialog)
    app.component('Divider', Divider)
    app.component('Dropdown', Dropdown)
    app.component('Editor', Editor)
    // app.component('Fieldset', Fieldset)
    app.component('FileUpload', FileUpload)
    // app.component('FullCalendar', FullCalendar)
    app.component('Image', Image)
    // app.component('InlineMessage', InlineMessage)
    // app.component('Inplace', Inplace)
    // app.component('InputMask', InputMask)
    app.component('InputNumber', InputNumber)
    // app.component('InputSwitch', InputSwitch)
    app.component('InputText', InputText)
    //app.component('Knob', Knob)
    // app.component('Listbox', Listbox)
    // app.component('MegaMenu', MegaMenu)
    // app.component('Menu', Menu)
    app.component('Menubar', Menubar)
    app.component('Message', Message)
    app.component('MultiSelect', MultiSelect)
    // app.component('OrderList', OrderList)
    // app.component('OrganizationChart', OrganizationChart)
    app.component('OverlayPanel', OverlayPanel)
    app.component('Paginator', Paginator)
    // app.component('Panel', Panel)
    app.component('PanelMenu', PanelMenu)
    app.component('Password', Password)
    // app.component('PickList', PickList)
    app.component('ProgressBar', ProgressBar)
    // app.component('ProgressSpinner', ProgressSpinner)
    app.component('RadioButton', RadioButton)
    app.component('Rating', Rating)
    // app.component('Row', Row)
    // app.component('ScrollPanel', ScrollPanel)
    // app.component('ScrollTop', ScrollTop)
    app.component('SelectButton', SelectButton)
    // app.component('Slider', Slider)
    // app.component('Sidebar', Sidebar)
    app.component('Skeleton', Skeleton)
    // app.component('SplitButton', SplitButton)
    // app.component('Splitter', Splitter)
    // app.component('SplitterPanel', SplitterPanel)
    app.component('Steps', Steps)
    // app.component('TabView', TabView)
    // app.component('TabPanel', TabPanel)
    // app.component('TabMenu', TabMenu)
    app.component('Tag', Tag)
    // app.component('Terminal', Terminal)
    app.component('Textarea', Textarea)
    // app.component('TieredMenu', TieredMenu)
    app.component('Timeline', Timeline)
    app.component('Toast', Toast)
    // app.component('Toolbar', Toolbar)
    // app.component('ToggleButton', ToggleButton)
    app.component('Tree', Tree)
    // app.component('TreeTable', TreeTable)
    // app.component('TriStateCheckbox', TriStateCheckbox)
    app.component('Galleria', Galleria)
}
